// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"6b781501","278":"bd93a5e7","405":"c01986e2","488":"f2f58a21","596":"a079426d","748":"34af6335","841":"8cd3da52","885":"7b62909c"}[chunkId] + ".chunk.js";
};